import { Navigate } from "react-router-dom";
import { useAuth } from "@/AuthContext";

export default function ProtectedRoute({ children }) {
    const { authState } = useAuth();
    if (authState === "checking") {
        return (
            <div
                className="min-h-screen flex items-center justify-center mono text-xs"
                style={{ color: "var(--text-faint)" }}
                data-testid="auth-checking"
            >
                authenticating…
            </div>
        );
    }
    if (authState !== "authed") {
        return <Navigate to="/login" replace />;
    }
    return children;
}
